/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { featureIcon } from 'services/featureIcon';
import { useDispatch } from 'react-redux';
import DashboardCompanyBreakdown from 'components/molecules/dashboard_company_breakdown';
import { CompanyCount } from 'hooks/useRepresentantDashboard';
import { ManagementTypes } from 'store/modules/management_store/types';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface CardDashboardServiceProps {
  title: string;
  img: string;
  value: number;
  error?: string;
  link: string;
  active?: boolean;
  locked?: boolean;
  tool?: string;
  tasks?: string;
  source?: string;
  trackName?: string;
  breakdown?: CompanyCount[];
}

const CardDashboardService: React.FC<CardDashboardServiceProps> = ({
  title,
  img,
  value,
  error,
  link,
  active,
  locked,
  tool,
  tasks,
  source,
  trackName,
  breakdown,
}) => {
  const dispatch = useDispatch();
  const [showBreakdown, setShowBreakdown] = useState(false);
  const breakdownItems = (breakdown || []).filter((item) => item.value !== 0);
  const breakdownId = `breakdown-${img}`;
  const breakdownTrigger =
    breakdownItems.length > 0
      ? {
          className: 'breakdown-trigger',
          tabIndex: 0,
          'aria-describedby': breakdownId,
          onMouseEnter: () => setShowBreakdown(true),
          onMouseLeave: () => setShowBreakdown(false),
          onFocus: () => setShowBreakdown(true),
          onBlur: () => setShowBreakdown(false),
        }
      : {};

  return (
    <Container
      className={`card-container ${source === 'dashboard' && 'h-100'} ${locked ? 'locked' : ''}`}
    >
      {active ? (
        <>
          <div className={`row ${source === 'dashboard' && 'mt-2'}`}>
            <div className="col">
              {error ? (
                <h3 className="font-weight-bold text-danger">{error}</h3>
              ) : (
                <h3 className="font-weight-bold">
                  <span {...breakdownTrigger}>{value}</span>
                </h3>
              )}
            </div>
            <div className="col text-right">
              <span {...breakdownTrigger}>
                <img alt={title} src={featureIcon(img)} width="24px" />
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">{title}</p>
            {!tasks ? (
              <button
                type="button"
                className="btn btn-link btn-sm p-0"
                disabled={locked}
                onClick={(event) => {
                  event.preventDefault();
                  createTrack(`Dashboard - Clicou em visualizar ferramenta ${trackName || title}`);
                  window.location.href = link;
                }}
              >
                Visualizar
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-link p-0"
                disabled={locked}
                onClick={() => {
                  createTrack(`Dashboard - Clicou em visualizar ferramenta ${trackName || title}`);
                  dispatch({
                    type: ManagementTypes.UPDATE_SELECTED_FEATURE,
                    selected_feature: tasks,
                  });
                  window.location.href = link;
                }}
              >
                Visualizar
              </button>
            )}
          </div>
          {showBreakdown && (
            <div className="breakdown-popover">
              <DashboardCompanyBreakdown
                id={breakdownId}
                title={title}
                total={value}
                items={breakdownItems}
              />
            </div>
          )}
        </>
      ) : (
        <div className="text-center">
          <p className="not-active-title">Você não tem assinatura do {tool}</p>
          <a href={link} className="btn btn-primary btn-sm">
            Assinar
          </a>
        </div>
      )}
    </Container>
  );
};

export default CardDashboardService;
